/**
 * Created by anatoly on 03.07.2025
 */

const WebMergeHintLogics = {
    type: "merge",
    priority: 8,

    findMove: function () {
        return MergeHintLogics.findMove(true);
    }
};

AvailableMove.REGISTERED_ALGORITHMS.push(WebMergeHintLogics);